
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/[category]",
      function () {
        return require("private-next-pages/faq/[category]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/[category]"])
      });
    }
  